<div class="stickyCart" matBadge="{{cartQuantity}}" *ngIf="cartQuantity && cartQuantity > 0" (click)="goToCartScroll()">
  <a href="javascript:void(0);">
    <i class="fa fa-shopping-basket" aria-hidden="true"></i>
  </a>
</div>

<div class="shoppingCart" matBadge="{{cartQuantity}}" *ngIf="cartQuantity && cartQuantity > 0 && stickyheight > 49"
  (click)="goToBusiness()">
  <span>
    <svg height="512pt" viewBox="-3 0 512 512" width="512pt" xmlns="http://www.w3.org/2000/svg">
      <path
        d="m494.929688 97.148438c-9.492188-10.84375-23.023438-16.816407-38.097657-16.816407h-364.429687l-3.667969-27.5c-3.953125-29.625-24.578125-52.832031-46.957031-52.832031h-26.777344c-8.285156 0-15 6.714844-15 15s6.714844 15 15 15h26.777344c4.8125 0 15.003906 10.175781 17.21875 26.796875l42.9375 322.039063c1.890625 14.195312 9.183594 27.484374 20.535156 37.421874 8.417969 7.371094 18.367188 12.273438 28.789062 14.324219-4.246093 7.808594-6.660156 16.753907-6.660156 26.25 0 30.421875 24.75 55.167969 55.167969 55.167969s55.167969-24.746094 55.167969-55.167969c0-9.0625-2.210938-17.613281-6.101563-25.164062h78.601563c-3.890625 7.550781-6.101563 16.101562-6.101563 25.164062 0 30.421875 24.75 55.167969 55.167969 55.167969s55.167969-24.746094 55.167969-55.167969c0-9.0625-2.210938-17.613281-6.101563-25.164062h39.300782c8.28125 0 15-6.71875 15-15 0-8.285157-6.71875-15-15-15h-302.589844c-14.65625 0-28.671875-12.273438-30.609375-26.800781l-3.136719-23.535157h116.746094c.003906 0 .007812.003907.011718.003907.003907 0 .007813-.003907.015626-.003907h96.367187c.003906 0 .007813.003907.015625.003907.003906 0 .003906-.003907.007812-.003907h83.003907c14.320312 0 28.457031-5.472656 39.808593-15.40625 11.351563-9.9375 18.644532-23.230469 20.535157-37.425781l21.515625-161.367188c1.992187-14.941406-2.136719-29.140624-11.628906-39.984374zm-269.996094 359.683593c0 13.878907-11.289063 25.167969-25.167969 25.167969-13.875 0-25.167969-11.289062-25.167969-25.167969 0-13.875 11.292969-25.164062 25.167969-25.164062 13.878906 0 25.167969 11.289062 25.167969 25.164062zm176.734375 0c0 13.878907-11.289063 25.167969-25.167969 25.167969s-25.167969-11.289062-25.167969-25.167969c0-13.875 11.289063-25.164062 25.167969-25.164062s25.167969 11.289062 25.167969 25.164062zm70.6875-339.921875c3.714843 4.242188 5.300781 10.011719 4.464843 16.253906l-9.019531 67.667969h-102.0625l6.03125-90.5h85.0625c6.300781 0 11.8125 2.335938 15.523438 6.578125zm-213.019531 204.421875-6.035157-90.5h80.371094l-6.035156 90.5zm-8.035157-120.5-6.03125-90.5h96.433594l-6.03125 90.5zm-36.097656-90.5 6.03125 90.5h-112.769531l-12.066406-90.5zm-102.738281 120.5h110.769531l6.035156 90.5h-104.738281zm312.234375 90.5h-66.996094l6.035156-90.5h100.0625l-8.492187 63.703125c-1.9375 14.527344-15.957032 26.796875-30.609375 26.796875zm0 0" />
    </svg>
  </span>
</div>


<section id="cover" [lazyLoad]="businessDetails.banner">
  <div class="container">
    <div class="row">
      <div class="col-md-12 col-sm-12 col-xs-12">
        <div class="banner-cover">
          <div class="banner-cover-itm-lft">
            <div class="business-logo">
              <img [lazyLoad]="businessDetails.logo" />
            </div>
            <div class="business-dtls">
              <div class="">
                <h4>{{businessDetails.name}}</h4>
                <p><span><i class="fa fa-clock-o" aria-hidden="true"></i></span>{{language.OPEN_TIME}}:
                  <span
                    *ngIf="businessDetails.time1 == false && businessDetails.time2 == false">{{language.CLOSE}}</span>
                  <span
                    *ngIf="businessDetails.time1 == true">{{businessDetails.today_schedule.opens.hour}}:{{businessDetails.today_schedule.opens.minute}}
                    -
                    {{businessDetails.today_schedule.closes.hour}}:{{businessDetails.today_schedule.closes.minute}}</span>
                  <span
                    *ngIf="businessDetails.time2 == true">&nbsp;&&nbsp;{{businessDetails.today_schedule.opens2.hour}}:{{businessDetails.today_schedule.opens2.minute}}
                    -
                    {{businessDetails.today_schedule.closes2.hour}}:{{businessDetails.today_schedule.closes2.minute}}</span>
                </p>
                <p><span><i class="fa fa-map-marker" aria-hidden="true"></i></span>{{businessDetails.address}}</p>
                <p><span><i class="fa fa-phone" aria-hidden="true"></i></span><a
                    href="tel:{{businessDetails.mobile}}">{{businessDetails.mobile}}</a>
                </p>
                <ul class="pmnt-icn">
                  <li *ngFor="let payment of businessDetails.payment | filterPayment: orderType"
                    tooltip="{{payment.displayName}}">
                    <img src="./assets/images/{{payment.name}}.png">
                  </li>
                </ul>
                <p class="fst-ordr at-item "
                  *ngIf="businessDetails.firstorderstatus == '1' && businessDetails.ordercountstatus">
                  {{language.FIRST_ORDER_DISCOUNT_1}}
                  {{businessDetails.currency_symbol}}{{businessDetails.firstordervalue}}
                  {{language.FIRST_ORDER_DISCOUNT_2}} {{businessDetails.firstorderoffer}}%
                  {{language.FIRST_TIME_ORDER}}.
                </p>
              </div>

            </div>
          </div>

          <div class="banner-cover-itm-ryt">
            <ul>
              <li>
                <a href="javascript:void(0);">
                  {{businessDetails.ratings}}/5
                </a>
              </li>
              <li (click)="ReviewOpen()">
                <a href="javascript:void(0);">
                  <i class="fa fa-star-o" aria-hidden="true"></i> {{language.ADD_REVIEWS}}
                </a>
              </li>
              <li *ngIf="appType" (click)="addToFav(businessDetails.id)" [ngClass]="{'active': FavBusiness == true }">
                <a href="javascript:void(0);">
                  <i class="fa fa-heart-o" aria-hidden="true"></i> {{language.FAV}}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section id="tab-menu">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12 col-sm-12 col-xs-12">
        <div class="business-info">
          <ul class="nav nav-tabs" id="myTab1">
            <li class=""><a href="#order" data-easein="fadeInUp" class="active">
                <span>
                  <svg height="512pt" viewBox="-3 0 512 512" width="512pt" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="m494.929688 97.148438c-9.492188-10.84375-23.023438-16.816407-38.097657-16.816407h-364.429687l-3.667969-27.5c-3.953125-29.625-24.578125-52.832031-46.957031-52.832031h-26.777344c-8.285156 0-15 6.714844-15 15s6.714844 15 15 15h26.777344c4.8125 0 15.003906 10.175781 17.21875 26.796875l42.9375 322.039063c1.890625 14.195312 9.183594 27.484374 20.535156 37.421874 8.417969 7.371094 18.367188 12.273438 28.789062 14.324219-4.246093 7.808594-6.660156 16.753907-6.660156 26.25 0 30.421875 24.75 55.167969 55.167969 55.167969s55.167969-24.746094 55.167969-55.167969c0-9.0625-2.210938-17.613281-6.101563-25.164062h78.601563c-3.890625 7.550781-6.101563 16.101562-6.101563 25.164062 0 30.421875 24.75 55.167969 55.167969 55.167969s55.167969-24.746094 55.167969-55.167969c0-9.0625-2.210938-17.613281-6.101563-25.164062h39.300782c8.28125 0 15-6.71875 15-15 0-8.285157-6.71875-15-15-15h-302.589844c-14.65625 0-28.671875-12.273438-30.609375-26.800781l-3.136719-23.535157h116.746094c.003906 0 .007812.003907.011718.003907.003907 0 .007813-.003907.015626-.003907h96.367187c.003906 0 .007813.003907.015625.003907.003906 0 .003906-.003907.007812-.003907h83.003907c14.320312 0 28.457031-5.472656 39.808593-15.40625 11.351563-9.9375 18.644532-23.230469 20.535157-37.425781l21.515625-161.367188c1.992187-14.941406-2.136719-29.140624-11.628906-39.984374zm-269.996094 359.683593c0 13.878907-11.289063 25.167969-25.167969 25.167969-13.875 0-25.167969-11.289062-25.167969-25.167969 0-13.875 11.292969-25.164062 25.167969-25.164062 13.878906 0 25.167969 11.289062 25.167969 25.164062zm176.734375 0c0 13.878907-11.289063 25.167969-25.167969 25.167969s-25.167969-11.289062-25.167969-25.167969c0-13.875 11.289063-25.164062 25.167969-25.164062s25.167969 11.289062 25.167969 25.164062zm70.6875-339.921875c3.714843 4.242188 5.300781 10.011719 4.464843 16.253906l-9.019531 67.667969h-102.0625l6.03125-90.5h85.0625c6.300781 0 11.8125 2.335938 15.523438 6.578125zm-213.019531 204.421875-6.035157-90.5h80.371094l-6.035156 90.5zm-8.035157-120.5-6.03125-90.5h96.433594l-6.03125 90.5zm-36.097656-90.5 6.03125 90.5h-112.769531l-12.066406-90.5zm-102.738281 120.5h110.769531l6.035156 90.5h-104.738281zm312.234375 90.5h-66.996094l6.035156-90.5h100.0625l-8.492187 63.703125c-1.9375 14.527344-15.957032 26.796875-30.609375 26.796875zm0 0" />
                  </svg>
                </span>
                {{language.ONLINE_ORDER}}</a>
            </li>
            <li><a href="#business" data-easein="fadeInUp">
                <span>
                  <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512"
                    style="enable-background:new 0 0 512 512;" xml:space="preserve">
                    <g>
                      <g>
                        <path d="M414.007,148.75c5.522,0,10-4.477,10-10V30c0-16.542-13.458-30-30-30h-364c-16.542,0-30,13.458-30,30v452
                         c0,16.542,13.458,30,30,30h364c16.542,0,30-13.458,30-30v-73.672c0-5.523-4.478-10-10-10c-5.522,0-10,4.477-10,10V482
                         c0,5.514-4.486,10-10,10h-364c-5.514,0-10-4.486-10-10V30c0-5.514,4.486-10,10-10h364c5.514,0,10,4.486,10,10v108.75
                         C404.007,144.273,408.485,148.75,414.007,148.75z" />
                      </g>
                    </g>
                    <g>
                      <g>
                        <path d="M212.007,54c-50.729,0-92,41.271-92,92c0,26.317,11.11,50.085,28.882,66.869c0.333,0.356,0.687,0.693,1.074,1
                         c16.371,14.979,38.158,24.13,62.043,24.13c23.885,0,45.672-9.152,62.043-24.13c0.387-0.307,0.741-0.645,1.074-1
                         c17.774-16.784,28.884-40.552,28.884-66.869C304.007,95.271,262.736,54,212.007,54z M212.007,218
                         c-16.329,0-31.399-5.472-43.491-14.668c8.789-15.585,25.19-25.332,43.491-25.332c18.301,0,34.702,9.747,43.491,25.332
                         C243.405,212.528,228.336,218,212.007,218z M196.007,142v-6.5c0-8.822,7.178-16,16-16s16,7.178,16,16v6.5c0,8.822-7.178,16-16,16
                         S196.007,150.822,196.007,142z M269.947,188.683c-7.375-10.938-17.596-19.445-29.463-24.697c4.71-6.087,7.523-13.712,7.523-21.986
                         v-6.5c0-19.851-16.149-36-36-36s-36,16.149-36,36v6.5c0,8.274,2.813,15.899,7.523,21.986
                         c-11.867,5.252-22.088,13.759-29.463,24.697c-8.829-11.953-14.06-26.716-14.06-42.683c0-39.701,32.299-72,72-72s72,32.299,72,72
                         C284.007,161.967,278.776,176.73,269.947,188.683z" />
                      </g>
                    </g>
                    <g>
                      <g>
                        <path
                          d="M266.007,438h-54c-5.522,0-10,4.477-10,10s4.478,10,10,10h54c5.522,0,10-4.477,10-10S271.529,438,266.007,438z" />
                      </g>
                    </g>
                    <g>
                      <g>
                        <path
                          d="M266.007,382h-142c-5.522,0-10,4.477-10,10s4.478,10,10,10h142c5.522,0,10-4.477,10-10S271.529,382,266.007,382z" />
                      </g>
                    </g>
                    <g>
                      <g>
                        <path
                          d="M266.007,326h-142c-5.522,0-10,4.477-10,10s4.478,10,10,10h142c5.522,0,10-4.477,10-10S271.529,326,266.007,326z" />
                      </g>
                    </g>
                    <g>
                      <g>
                        <path d="M88.366,272.93c-1.859-1.86-4.439-2.93-7.079-2.93c-2.631,0-5.211,1.07-7.07,2.93c-1.86,1.86-2.93,4.44-2.93,7.07
                         s1.069,5.21,2.93,7.07c1.87,1.86,4.439,2.93,7.07,2.93c2.64,0,5.21-1.07,7.079-2.93c1.86-1.86,2.931-4.44,2.931-7.07
                         S90.227,274.79,88.366,272.93z" />
                      </g>
                    </g>
                    <g>
                      <g>
                        <path d="M88.366,328.93c-1.869-1.86-4.439-2.93-7.079-2.93c-2.631,0-5.2,1.07-7.07,2.93c-1.86,1.86-2.93,4.44-2.93,7.07
                         s1.069,5.21,2.93,7.07c1.87,1.86,4.439,2.93,7.07,2.93c2.64,0,5.21-1.07,7.079-2.93c1.86-1.86,2.931-4.44,2.931-7.07
                         S90.227,330.79,88.366,328.93z" />
                      </g>
                    </g>
                    <g>
                      <g>
                        <path d="M88.366,384.93c-1.869-1.86-4.439-2.93-7.079-2.93c-2.631,0-5.2,1.07-7.07,2.93c-1.86,1.86-2.93,4.44-2.93,7.07
                         s1.069,5.21,2.93,7.07c1.859,1.86,4.439,2.93,7.07,2.93c2.64,0,5.22-1.07,7.079-2.93c1.86-1.86,2.931-4.44,2.931-7.07
                         S90.227,386.79,88.366,384.93z" />
                      </g>
                    </g>
                    <g>
                      <g>
                        <path
                          d="M266.007,270h-142c-5.522,0-10,4.477-10,10s4.478,10,10,10h142c5.522,0,10-4.477,10-10S271.529,270,266.007,270z" />
                      </g>
                    </g>
                    <g>
                      <g>
                        <path d="M491.002,130.32c-9.715-5.609-21.033-7.099-31.871-4.196c-10.836,2.904-19.894,9.854-25.502,19.569L307.787,363.656
                         c-0.689,1.195-1.125,2.52-1.278,3.891l-8.858,79.344c-0.44,3.948,1.498,7.783,4.938,9.77c1.553,0.896,3.278,1.34,4.999,1.34
                         c2.092,0,4.176-0.655,5.931-1.948l64.284-47.344c1.111-0.818,2.041-1.857,2.73-3.052l125.841-217.963
                         C517.954,167.638,511.058,141.9,491.002,130.32z M320.063,426.394l4.626-41.432l28.942,16.71L320.063,426.394z M368.213,386.996
                         l-38.105-22l100.985-174.91l38.105,22L368.213,386.996z M489.054,177.693l-9.857,17.073l-38.105-22l9.857-17.073
                         c2.938-5.089,7.682-8.729,13.358-10.25c5.678-1.522,11.606-0.74,16.694,2.198c5.089,2.938,8.729,7.682,10.25,13.358
                         C492.772,166.675,491.992,172.604,489.054,177.693z" />
                      </g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                  </svg>

                </span>
                {{language.BUSINESS_INFO}}</a>
            </li>
            <li><a href="#photos" data-easein="fadeInUp">
                <span>
                  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512"
                    style="enable-background:new 0 0 512 512;" xml:space="preserve">
                    <g>
                      <g>
                        <path d="M489.396,44.856H22.604C10.14,44.856,0,54.996,0,67.46V444.54c0,12.464,10.14,22.604,22.604,22.604h466.792
                         c12.464,0,22.604-10.14,22.604-22.604V67.46C512,54.996,501.86,44.856,489.396,44.856z M489.396,444.54l-466.791,0.015
                         c0,0-0.001-0.005-0.001-0.015V67.46h466.792V444.54z" />
                      </g>
                    </g>
                    <g>
                      <g>
                        <path d="M446.975,98.58H65.024c-6.241,0-11.302,5.061-11.302,11.302v249.8c0,6.241,5.061,11.301,11.302,11.301h381.95
                         c6.241,0,11.302-5.061,11.302-11.302V109.882C458.277,103.641,453.216,98.58,446.975,98.58z M76.326,121.184h359.346v191.334
                         l-71.228-71.22c-4.412-4.412-11.568-4.412-15.983,0l-43.421,43.421l-99.56-99.56c-4.413-4.41-11.569-4.412-15.983,0
                         l-113.17,113.16V121.184z M76.326,348.378v-18.095l121.162-121.15l139.244,139.245H76.326z M435.674,348.379h-66.973v-0.001
                         l-47.676-47.676l35.429-35.43l76.622,76.612c0.788,0.788,1.666,1.43,2.597,1.936V348.379z" />
                      </g>
                    </g>
                    <g>
                      <g>
                        <path d="M304.345,142.629c-23.56,0-42.729,19.168-42.729,42.729s19.168,42.729,42.729,42.729s42.729-19.168,42.729-42.729
                         S327.905,142.629,304.345,142.629z M304.345,205.483c-11.098,0-20.125-9.027-20.125-20.125c0-11.097,9.028-20.124,20.125-20.124
                         c11.096,0,20.124,9.027,20.124,20.124C324.469,196.456,315.442,205.483,304.345,205.483z" />
                      </g>
                    </g>
                    <g>
                      <g>
                        <path d="M163.332,396.458H65.024c-6.241,0-11.302,5.061-11.302,11.302c0,6.242,5.061,11.302,11.302,11.302h98.308
                         c6.242,0,11.302-5.061,11.302-11.302C174.634,401.519,169.574,396.458,163.332,396.458z" />
                      </g>
                    </g>
                    <g>
                      <g>
                        <path d="M240.689,396.458h-25.785c-6.241,0-11.302,5.061-11.302,11.302c0,6.241,5.061,11.302,11.302,11.302h25.785
                         c6.242,0,11.302-5.061,11.302-11.302C251.991,401.519,246.93,396.458,240.689,396.458z" />
                      </g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                  </svg>

                </span>
                {{language.PHOTOS}}</a>
            </li>
            <li class="rrr"><a href="#reviews" data-easein="fadeInUp">
                <span>
                  <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 487.222 487.222"
                    style="enable-background:new 0 0 487.222 487.222;" xml:space="preserve">
                    <g>
                      <path
                        d="M486.554,186.811c-1.6-4.9-5.8-8.4-10.9-9.2l-152-21.6l-68.4-137.5c-2.3-4.6-7-7.5-12.1-7.5l0,0c-5.1,0-9.8,2.9-12.1,7.6
                       l-67.5,137.9l-152,22.6c-5.1,0.8-9.3,4.3-10.9,9.2s-0.2,10.3,3.5,13.8l110.3,106.9l-25.5,151.4c-0.9,5.1,1.2,10.2,5.4,13.2
                       c2.3,1.7,5.1,2.6,7.9,2.6c2.2,0,4.3-0.5,6.3-1.6l135.7-71.9l136.1,71.1c2,1,4.1,1.5,6.2,1.5l0,0c7.4,0,13.5-6.1,13.5-13.5
                       c0-1.1-0.1-2.1-0.4-3.1l-26.3-150.5l109.6-107.5C486.854,197.111,488.154,191.711,486.554,186.811z M349.554,293.911
                       c-3.2,3.1-4.6,7.6-3.8,12l22.9,131.3l-118.2-61.7c-3.9-2.1-8.6-2-12.6,0l-117.8,62.4l22.1-131.5c0.7-4.4-0.7-8.8-3.9-11.9
                       l-95.6-92.8l131.9-19.6c4.4-0.7,8.2-3.4,10.1-7.4l58.6-119.7l59.4,119.4c2,4,5.8,6.7,10.2,7.4l132,18.8L349.554,293.911z" />
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                  </svg>

                </span>

                {{language.REVIEWS}}</a>
            </li>
            <li><a href="#offers" data-easein="fadeInUp">
                <span>
                  <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512.003 512.003"
                    style="enable-background:new 0 0 512.003 512.003;" xml:space="preserve">
                    <g>
                      <g>
                        <path d="M477.958,262.633c-2.06-4.215-2.06-9.049,0-13.263l19.096-39.065c10.632-21.751,2.208-47.676-19.178-59.023l-38.41-20.38
                         c-4.144-2.198-6.985-6.11-7.796-10.729l-7.512-42.829c-4.183-23.846-26.241-39.87-50.208-36.479l-43.053,6.09
                         c-4.647,0.656-9.242-0.838-12.613-4.099l-31.251-30.232c-17.401-16.834-44.661-16.835-62.061,0L193.72,42.859
                         c-3.372,3.262-7.967,4.753-12.613,4.099l-43.053-6.09c-23.975-3.393-46.025,12.633-50.208,36.479l-7.512,42.827
                         c-0.811,4.62-3.652,8.531-7.795,10.73l-38.41,20.38c-21.386,11.346-29.81,37.273-19.178,59.024l19.095,39.064
                         c2.06,4.215,2.06,9.049,0,13.263l-19.096,39.064c-10.632,21.751-2.208,47.676,19.178,59.023l38.41,20.38
                         c4.144,2.198,6.985,6.11,7.796,10.729l7.512,42.829c3.808,21.708,22.422,36.932,43.815,36.93c2.107,0,4.245-0.148,6.394-0.452
                         l43.053-6.09c4.643-0.659,9.241,0.838,12.613,4.099l31.251,30.232c8.702,8.418,19.864,12.626,31.03,12.625
                         c11.163-0.001,22.332-4.209,31.03-12.625l31.252-30.232c3.372-3.261,7.968-4.751,12.613-4.099l43.053,6.09
                         c23.978,3.392,46.025-12.633,50.208-36.479l7.513-42.827c0.811-4.62,3.652-8.531,7.795-10.73l38.41-20.38
                         c21.386-11.346,29.81-37.273,19.178-59.024L477.958,262.633z M464.035,334.635l-38.41,20.38
                         c-12.246,6.499-20.645,18.057-23.04,31.713l-7.512,42.828c-1.415,8.068-8.874,13.487-16.987,12.342l-43.053-6.09
                         c-13.73-1.945-27.316,2.474-37.281,12.113L266.5,478.152c-5.886,5.694-15.109,5.694-20.997,0l-31.251-30.232
                         c-8.422-8.147-19.432-12.562-30.926-12.562c-2.106,0-4.229,0.148-6.355,0.449l-43.053,6.09
                         c-8.106,1.146-15.571-4.274-16.987-12.342l-7.513-42.829c-2.396-13.656-10.794-25.215-23.041-31.712l-38.41-20.38
                         c-7.236-3.839-10.086-12.61-6.489-19.969l19.096-39.065c6.088-12.456,6.088-26.742,0-39.198l-19.096-39.065
                         c-3.597-7.359-0.747-16.13,6.489-19.969l38.41-20.38c12.246-6.499,20.645-18.057,23.04-31.713l7.512-42.828
                         c1.416-8.068,8.874-13.488,16.987-12.342l43.053,6.09c13.725,1.943,27.316-2.474,37.281-12.113l31.252-30.232
                         c5.886-5.694,15.109-5.694,20.997,0l31.251,30.232c9.965,9.64,23.554,14.056,37.281,12.113l43.053-6.09
                         c8.107-1.147,15.572,4.274,16.987,12.342l7.512,42.829c2.396,13.656,10.794,25.215,23.041,31.712l38.41,20.38
                         c7.236,3.839,10.086,12.61,6.489,19.969l-19.096,39.064c-6.088,12.455-6.088,26.743,0,39.198l19.096,39.064
                         C474.121,322.024,471.271,330.796,464.035,334.635z" />
                      </g>
                    </g>
                    <g>
                      <g>
                        <path d="M363.886,148.116c-5.765-5.766-15.115-5.766-20.881,0L148.116,343.006c-5.766,5.766-5.766,15.115,0,20.881
                         c2.883,2.883,6.662,4.325,10.44,4.325c3.778,0,7.558-1.441,10.44-4.325l194.889-194.889
                         C369.653,163.231,369.653,153.883,363.886,148.116z" />
                      </g>
                    </g>
                    <g>
                      <g>
                        <path d="M196.941,123.116c-29.852,0-54.139,24.287-54.139,54.139s24.287,54.139,54.139,54.139s54.139-24.287,54.139-54.139
                         S226.793,123.116,196.941,123.116z M196.941,201.863c-13.569,0-24.608-11.039-24.608-24.609c0-13.569,11.039-24.608,24.608-24.608
                         c13.569,0,24.609,11.039,24.609,24.608C221.549,190.824,210.51,201.863,196.941,201.863z" />
                      </g>
                    </g>
                    <g>
                      <g>
                        <path
                          d="M315.061,280.61c-29.852,0-54.139,24.287-54.139,54.139s24.287,54.139,54.139,54.139
                         c29.852,0,54.139-24.287,54.139-54.139S344.913,280.61,315.061,280.61z M315.061,359.357c-13.569,0-24.609-11.039-24.609-24.608
                         s11.039-24.608,24.609-24.608c13.569,0,24.608,11.039,24.608,24.608S328.63,359.357,315.061,359.357z" />
                      </g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                  </svg>

                </span>
                {{language.OFFERS}}</a>
            </li>
            <li *ngIf="businessDetails.bookingstatus == '1'"><a href="#booking" data-easein="fadeInUp">
                <span>
                  <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512"
                    style="enable-background:new 0 0 512 512;" xml:space="preserve">
                    <g>
                      <g>
                        <g>
                          <circle cx="386" cy="210" r="20" />
                          <path d="M432,40h-26V20c0-11.046-8.954-20-20-20c-11.046,0-20,8.954-20,20v20h-91V20c0-11.046-8.954-20-20-20
				c-11.046,0-20,8.954-20,20v20h-90V20c0-11.046-8.954-20-20-20s-20,8.954-20,20v20H80C35.888,40,0,75.888,0,120v312
				c0,44.112,35.888,80,80,80h153c11.046,0,20-8.954,20-20c0-11.046-8.954-20-20-20H80c-22.056,0-40-17.944-40-40V120
				c0-22.056,17.944-40,40-40h25v20c0,11.046,8.954,20,20,20s20-8.954,20-20V80h90v20c0,11.046,8.954,20,20,20s20-8.954,20-20V80h91
				v20c0,11.046,8.954,20,20,20c11.046,0,20-8.954,20-20V80h26c22.056,0,40,17.944,40,40v114c0,11.046,8.954,20,20,20
				c11.046,0,20-8.954,20-20V120C512,75.888,476.112,40,432,40z" />
                          <path d="M391,270c-66.72,0-121,54.28-121,121s54.28,121,121,121s121-54.28,121-121S457.72,270,391,270z M391,472
				c-44.663,0-81-36.336-81-81s36.337-81,81-81c44.663,0,81,36.336,81,81S435.663,472,391,472z" />
                          <path d="M420,371h-9v-21c0-11.046-8.954-20-20-20c-11.046,0-20,8.954-20,20v41c0,11.046,8.954,20,20,20h29
				c11.046,0,20-8.954,20-20C440,379.954,431.046,371,420,371z" />
                          <circle cx="299" cy="210" r="20" />
                          <circle cx="212" cy="297" r="20" />
                          <circle cx="125" cy="210" r="20" />
                          <circle cx="125" cy="297" r="20" />
                          <circle cx="125" cy="384" r="20" />
                          <circle cx="212" cy="384" r="20" />
                          <circle cx="212" cy="210" r="20" />
                        </g>
                      </g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                  </svg>

                </span>
                {{language.BOOKING}}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<div class="tab-dtls ">
  <div class="container-fluid">
    <div class="tab-content" id="tab-content1">
      <div class="tab-pane active" id="order">
        <div class="row" *ngIf="businessDetails.open == false">
          <div class="col-md-12">
            <div class="alrt">
              <p>{{language.PREORDER_DESCR}} </p>
            </div>
          </div>
        </div>
        <div class="row m-preorder" style="display: none;">
          <div class="col-md-12">
            <button class="cmn-button" (click)="goToPreorder()">{{language.PREORDER}}</button>
            <mat-chip-list class="preorderText" #chipList *ngIf="preorderDetails.preorder == true">
              <mat-chip class="mb-20" [selectable]="selectable" [removable]="removable">
                {{preorderDetails.preorderDateString}} -
                {{preorderDetails.preorderTime}}
                <i class="fa fa-times" aria-hidden="true" (click)="removePreorder()"></i>
              </mat-chip>
            </mat-chip-list>
          </div>
        </div>
        <div class="row">
          <div class="col-md-8 col-sm-12 col-xs-12">
            <div class="menu" *ngIf="menuDisplay == true">
              <div class="menu-search" id="menuSearch">
                <div class="form-group">
                  <input type="text" class="form-control" autocomplete="off" name="name"
                    placeholder="{{language.SEARCH}}..." [(ngModel)]="searchText" />
                  <a href="javascript:void(0);"><i class="fa fa-search" aria-hidden="true"></i></a>
                </div>
              </div>
              <div class="manu-ctgry police" id="anchorDiv">
                <mat-tab-group>
                  <mat-tab *ngFor="let cat of myClonedcategory">
                    <ng-template mat-tab-label *ngIf="checkSubCatExist(cat.subCat) == true">
                      <a mat-icon-button class="cloneIcon" (click)="scrollTab(cat.id)">
                        <small></small>{{cat.name}}
                      </a>
                    </ng-template>

                    <ng-template mat-tab-label *ngIf="checkSubCatExist(cat.subCat) == false">
                      <a mat-icon-button [matMenuTriggerFor]="Menu" class="cloneIcon" (click)="scrollTab(cat.id)">
                        <small></small>{{cat.name}}<span></span>
                      </a>
                    </ng-template>
                    <mat-menu #Menu="matMenu" class="my-full-width-menu">
                      <button mat-menu-item *ngFor="let sub of cat.subCat" [hidden]="sub.active == false"
                        (click)="scrollSubTab(cat.id, sub.id)">{{sub.name}}</button>
                    </mat-menu>


                  </mat-tab>
                </mat-tab-group>
              </div>


              <div class="loader" *ngIf="productDisplay == false"></div>
              <!-- Product List -->
              <div class="main-menu" *ngFor="let cat of myClonedcategory" id="anchor{{cat.id}}">
                <div *ngIf="cat.activeDish">
                  <div *ngFor="let dish of cat.dish | filter : searchText as filtered_result;let i = index">
                    <div class="main-menu-hdn" *ngIf="i == 0 && filtered_result.length > 0">
                      <h4>{{cat.name}}</h4>
                      <p>{{cat.descr}}</p>
                    </div>
                  </div>
                  <div class="main-menu-grp">
                    <div class="main-menu-item" *ngFor="let dish of cat.dish | filter : searchText"
                      [hidden]="dish.subcategory != 0"
                      [ngClass]="((businessDetails.open == true && dish.dishstatus == 1) || preorderDetails.preorder == true)?'opendish':'closedish'">
                      <span *ngIf="dish.feature == 1" class="ftrd-prdct">{{language.FEATURED}}</span>
                      <div class="main-menu-item-pic"
                        *ngIf="dish.is_img == 1 || dish.is_img1 == 1 || dish.is_img2 == 1">
                        <a *ngIf="dish.is_img == 1" data-fancybox href="{{dish.img}}">
                          <img [lazyLoad]="dish.img" />
                        </a>
                        <a *ngIf="dish.is_img == 0 && dish.is_img1 == 1" data-fancybox href="{{dish.img1}}">
                          <img [lazyLoad]="dish.img1" />
                        </a>
                        <a *ngIf="dish.is_img == 0 && dish.is_img1 == 0 && dish.is_img2 == 1" data-fancybox
                          href="{{dish.img2}}">
                          <img [lazyLoad]="dish.img2" />
                        </a>
                      </div>
                      <div class="main-menu-item-dtls"
                        [ngClass]="{'full-wdth':dish.is_img == 0 && dish.is_img1 == 0 && dish.is_img2 == 0, 'ftrd-div': dish.feature == 1}">
                        <h4>{{dish.name}}
                          <span [ngClass]="{'veg':dish.veg == 1, 'non-veg':dish.nonveg == 1}"></span>
                          <span *ngIf="dish.freeitem.length > 0 && businessDetails.buyone_getone_status" class="buy-get">Buy 1 Get 1 Free</span>
                        </h4>
                        <p *ngIf="dish.description != ''">{{dish.description}}</p>
                        <div class="price-add">
                          <div>
                            <span *ngIf="orderType != '2' && dish.offerprice > 0"
                              class="line-cut">{{businessDetails.currency_symbol}}{{dish.delprice}}</span>
                            <span *ngIf="orderType == '2' && dish.pofferprice > 0"
                              class="line-cut">{{businessDetails.currency_symbol}}{{dish.pickprice}}</span>
                            <span *ngIf="dish.price > 0">
                              {{businessDetails.currency_symbol}}{{dish.price}}
                            </span>
                            <a href="javascript:void(0);" (click)="openProduct(cat.id, dish)"
                              *ngIf="((businessDetails.open == true && dish.dishstatus == 1) || preorderDetails.preorder == true) && businessDetails.bclosed == false"><i
                                class="fa fa-plus" aria-hidden="true"></i>
                              <span class=" cart_ani  cart__animation_{{dish.id}}"> <svg height="512pt"
                                  viewBox="-3 0 512 512" width="512pt" xmlns="http://www.w3.org/2000/svg">
                                  <path
                                    d="m494.929688 97.148438c-9.492188-10.84375-23.023438-16.816407-38.097657-16.816407h-364.429687l-3.667969-27.5c-3.953125-29.625-24.578125-52.832031-46.957031-52.832031h-26.777344c-8.285156 0-15 6.714844-15 15s6.714844 15 15 15h26.777344c4.8125 0 15.003906 10.175781 17.21875 26.796875l42.9375 322.039063c1.890625 14.195312 9.183594 27.484374 20.535156 37.421874 8.417969 7.371094 18.367188 12.273438 28.789062 14.324219-4.246093 7.808594-6.660156 16.753907-6.660156 26.25 0 30.421875 24.75 55.167969 55.167969 55.167969s55.167969-24.746094 55.167969-55.167969c0-9.0625-2.210938-17.613281-6.101563-25.164062h78.601563c-3.890625 7.550781-6.101563 16.101562-6.101563 25.164062 0 30.421875 24.75 55.167969 55.167969 55.167969s55.167969-24.746094 55.167969-55.167969c0-9.0625-2.210938-17.613281-6.101563-25.164062h39.300782c8.28125 0 15-6.71875 15-15 0-8.285157-6.71875-15-15-15h-302.589844c-14.65625 0-28.671875-12.273438-30.609375-26.800781l-3.136719-23.535157h116.746094c.003906 0 .007812.003907.011718.003907.003907 0 .007813-.003907.015626-.003907h96.367187c.003906 0 .007813.003907.015625.003907.003906 0 .003906-.003907.007812-.003907h83.003907c14.320312 0 28.457031-5.472656 39.808593-15.40625 11.351563-9.9375 18.644532-23.230469 20.535157-37.425781l21.515625-161.367188c1.992187-14.941406-2.136719-29.140624-11.628906-39.984374zm-269.996094 359.683593c0 13.878907-11.289063 25.167969-25.167969 25.167969-13.875 0-25.167969-11.289062-25.167969-25.167969 0-13.875 11.292969-25.164062 25.167969-25.164062 13.878906 0 25.167969 11.289062 25.167969 25.164062zm176.734375 0c0 13.878907-11.289063 25.167969-25.167969 25.167969s-25.167969-11.289062-25.167969-25.167969c0-13.875 11.289063-25.164062 25.167969-25.164062s25.167969 11.289062 25.167969 25.164062zm70.6875-339.921875c3.714843 4.242188 5.300781 10.011719 4.464843 16.253906l-9.019531 67.667969h-102.0625l6.03125-90.5h85.0625c6.300781 0 11.8125 2.335938 15.523438 6.578125zm-213.019531 204.421875-6.035157-90.5h80.371094l-6.035156 90.5zm-8.035157-120.5-6.03125-90.5h96.433594l-6.03125 90.5zm-36.097656-90.5 6.03125 90.5h-112.769531l-12.066406-90.5zm-102.738281 120.5h110.769531l6.035156 90.5h-104.738281zm312.234375 90.5h-66.996094l6.035156-90.5h100.0625l-8.492187 63.703125c-1.9375 14.527344-15.957032 26.796875-30.609375 26.796875zm0 0" />
                                </svg></span>
                            </a>
                          </div>
                          <div class="cstmz-div">
                            <span class="cstmz" *ngIf="dish.sets.length > 0">{{language.CUSTOMIZABLE}}</span>
                          </div>
                        </div>
                        <div class="spycy" *ngIf="dish.spicy == 1">
                          <label>How Spicy ?</label>
                          <mat-slider thumbLabel class="spicy-slider" [displayWith]="formatLabel"
                            [(ngModel)]="dish.spicyquantity" tickInterval="1" min="1" max="3"></mat-slider>
                        </div>
                      </div>
                    </div>
                    <div class="sub-menu" *ngFor="let subCat of cat.subCat" id="anchor{{cat.id}}_{{subCat.id}}"
                      [hidden]="subCat.active == false">
                      <div *ngFor="let dish of subCat.dish | filter : searchText as filtered_result;let i = index">
                        <div class="sub-menu-hdn" *ngIf="i == 0 && filtered_result.length > 0">
                          <h4>{{cat.name}} <span><i class="fa fa-angle-right" aria-hidden="true"></i></span>
                            {{subCat.name}}</h4>
                        </div>
                      </div>

                      <div class="sub-menu-grp">
                        <div class="main-menu-item" *ngFor="let dish of subCat.dish | filter : searchText"
                          [ngClass]="((businessDetails.open == true && dish.dishstatus == 1) || preorderDetails.preorder == true)?'opendish':'closedish'">
                          <span *ngIf="dish.feature == 1" class="ftrd-prdct">{{language.FEATURED}}</span>
                          <div class="main-menu-item-pic"
                            *ngIf="dish.is_img == 1 || dish.is_img1 == 1 || dish.is_img2 == 1">
                            <a *ngIf="dish.is_img == 1" data-fancybox href="{{dish.img}}">
                              <img [lazyLoad]="dish.img" />
                            </a>
                            <a *ngIf="dish.is_img == 0 && dish.is_img1 == 1" data-fancybox href="{{dish.img1}}">
                              <img [lazyLoad]="dish.img1" />
                            </a>
                            <a *ngIf="dish.is_img == 0 && dish.is_img1 == 0 && dish.is_img2 == 1" data-fancybox
                              href="{{dish.img2}}">
                              <img [lazyLoad]="dish.img2" />
                            </a>
                          </div>
                          <div class="main-menu-item-dtls"
                            [ngClass]="{'full-wdth':dish.is_img == 0 && dish.is_img1 == 0 && dish.is_img2 == 0, 'ftrd-div': dish.feature == 1}">
                            <h4>{{dish.name}}
                              <span [ngClass]="{'veg':dish.veg == 1, 'non-veg':dish.nonveg == 1}"></span>
                              <span *ngIf="dish.freeitem.length > 0 && businessDetails.buyone_getone_status" class="buy-get">Buy 1 Get 1 Free</span>
                            </h4>
                            <p *ngIf="dish.description != ''">{{dish.description}}</p>
                            <div class="price-add">
                              <div>
                                <span *ngIf="orderType != '2' && dish.offerprice > 0"
                                  class="line-cut">{{businessDetails.currency_symbol}}{{dish.delprice}}</span>
                                <span *ngIf="orderType == '2' && dish.pofferprice > 0"
                                  class="line-cut">{{businessDetails.currency_symbol}}{{dish.pickprice}}</span>
                                <span *ngIf="dish.price > 0">
                                  {{businessDetails.currency_symbol}}{{dish.price}}
                                </span>

                                <a href="javascript:void(0);" (click)="openProduct(cat.id, dish)"
                                  *ngIf="((businessDetails.open == true && dish.dishstatus == 1) || preorderDetails.preorder == true) && businessDetails.bclosed == false"><i
                                    class="fa fa-plus" aria-hidden="true"></i>
                                  <span class=" cart_ani cart__animation_{{dish.id}}"> <svg height="512pt"
                                      viewBox="-3 0 512 512" width="512pt" xmlns="http://www.w3.org/2000/svg">
                                      <path
                                        d="m494.929688 97.148438c-9.492188-10.84375-23.023438-16.816407-38.097657-16.816407h-364.429687l-3.667969-27.5c-3.953125-29.625-24.578125-52.832031-46.957031-52.832031h-26.777344c-8.285156 0-15 6.714844-15 15s6.714844 15 15 15h26.777344c4.8125 0 15.003906 10.175781 17.21875 26.796875l42.9375 322.039063c1.890625 14.195312 9.183594 27.484374 20.535156 37.421874 8.417969 7.371094 18.367188 12.273438 28.789062 14.324219-4.246093 7.808594-6.660156 16.753907-6.660156 26.25 0 30.421875 24.75 55.167969 55.167969 55.167969s55.167969-24.746094 55.167969-55.167969c0-9.0625-2.210938-17.613281-6.101563-25.164062h78.601563c-3.890625 7.550781-6.101563 16.101562-6.101563 25.164062 0 30.421875 24.75 55.167969 55.167969 55.167969s55.167969-24.746094 55.167969-55.167969c0-9.0625-2.210938-17.613281-6.101563-25.164062h39.300782c8.28125 0 15-6.71875 15-15 0-8.285157-6.71875-15-15-15h-302.589844c-14.65625 0-28.671875-12.273438-30.609375-26.800781l-3.136719-23.535157h116.746094c.003906 0 .007812.003907.011718.003907.003907 0 .007813-.003907.015626-.003907h96.367187c.003906 0 .007813.003907.015625.003907.003906 0 .003906-.003907.007812-.003907h83.003907c14.320312 0 28.457031-5.472656 39.808593-15.40625 11.351563-9.9375 18.644532-23.230469 20.535157-37.425781l21.515625-161.367188c1.992187-14.941406-2.136719-29.140624-11.628906-39.984374zm-269.996094 359.683593c0 13.878907-11.289063 25.167969-25.167969 25.167969-13.875 0-25.167969-11.289062-25.167969-25.167969 0-13.875 11.292969-25.164062 25.167969-25.164062 13.878906 0 25.167969 11.289062 25.167969 25.164062zm176.734375 0c0 13.878907-11.289063 25.167969-25.167969 25.167969s-25.167969-11.289062-25.167969-25.167969c0-13.875 11.289063-25.164062 25.167969-25.164062s25.167969 11.289062 25.167969 25.164062zm70.6875-339.921875c3.714843 4.242188 5.300781 10.011719 4.464843 16.253906l-9.019531 67.667969h-102.0625l6.03125-90.5h85.0625c6.300781 0 11.8125 2.335938 15.523438 6.578125zm-213.019531 204.421875-6.035157-90.5h80.371094l-6.035156 90.5zm-8.035157-120.5-6.03125-90.5h96.433594l-6.03125 90.5zm-36.097656-90.5 6.03125 90.5h-112.769531l-12.066406-90.5zm-102.738281 120.5h110.769531l6.035156 90.5h-104.738281zm312.234375 90.5h-66.996094l6.035156-90.5h100.0625l-8.492187 63.703125c-1.9375 14.527344-15.957032 26.796875-30.609375 26.796875zm0 0" />
                                    </svg></span>
                                </a>
                              </div>
                              <div class="cstmz-div">
                                <span class="cstmz" *ngIf="dish.sets.length > 0">{{language.CUSTOMIZABLE}}</span>

                              </div>

                            </div>
                            <div class="spycy" *ngIf="dish.spicy == 1">
                              <label>How Spicy ?</label>
                              <mat-slider thumbLabel class="spicy-slider" [displayWith]="formatLabel"
                                [(ngModel)]="dish.spicyquantity" tickInterval="1" min="1" max="3"></mat-slider>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
              <!-- Product List -->
            </div>
            <div class="menu" *ngIf="menuDisplay == false">
              <mat-card class="no-item">
                <p>{{language.NO_PRODUCT}}</p>
              </mat-card>
            </div>
          </div>

          <div class="col-md-4 col-sm-12 col-xs-12 ">
            <div *ngIf="businessDetails.freedeliverystatus == '1' && orderType != '2'" class="free-delivery-box">
              <img [lazyLoad]="carImage"> <span>{{language.MINIMUM_FREE_DELIVERY}}
                {{businessDetails.currency_symbol}}{{businessDetails.freedeliveryvalue}}</span>
            </div>
            <div class="your-order police" id="cartscroll">
              <div>
                <h4>
                  <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 487.1 487.1"
                    style="enable-background:new 0 0 487.1 487.1;" xml:space="preserve">
                    <g>
                      <g>
                        <path
                          d="M342.3,137.978H385l-63.3-108.6c-5.1-8.8-16.4-11.8-25.2-6.6c-8.8,5.1-11.8,16.4-6.6,25.2L342.3,137.978z" />
                        <path
                          d="M197.4,47.978c5.1-8.8,2.2-20.1-6.6-25.2s-20.1-2.2-25.2,6.6l-63.3,108.7H145L197.4,47.978z" />
                        <path
                          d="M455.7,171.278H31.3c-17.3,0-31.3,14-31.3,31.3v34.7c0,17.3,14,31.3,31.3,31.3h9.8l30.2,163.7 c3.8,19.3,21.4,34.6,39.7,34.6h12h78.8c8,0,18.4,0,29,0l0,0h9.6h9.6l0,0c10.6,0,21,0,29,0h78.8h12c18.3,0,35.9-15.3,39.7-34.6 l30.4-163.8h15.9c17.3,0,31.3-14,31.3-31.3v-34.7C487,185.278,473,171.278,455.7,171.278z M172.8,334.878v70.6 c0,10.1-8.2,17.7-17.7,17.7c-10.1,0-17.7-8.2-17.7-17.7v-29.6v-69.4c0-10.1,8.2-17.7,17.7-17.7c10.1,0,17.7,8.2,17.7,17.7V334.878 z M229.6,334.878v70.6c0,10.1-8.2,17.7-17.7,17.7c-10.1,0-17.7-8.2-17.7-17.7v-29.6v-69.4c0-10.1,8.2-17.7,17.7-17.7 s17.7,8.2,17.7,17.7V334.878z M286.7,375.878v29.6c0,9.5-7.6,17.7-17.7,17.7c-9.5,0-17.7-7.6-17.7-17.7v-70.6v-28.4 c0-9.5,8.2-17.7,17.7-17.7s17.7,7.6,17.7,17.7V375.878z M343.5,375.878v29.6c0,9.5-7.6,17.7-17.7,17.7c-9.5,0-17.7-7.6-17.7-17.7 v-70.6v-28.4c0-9.5,7.6-17.7,17.7-17.7c9.5,0,17.7,7.6,17.7,17.7V375.878z" />
                      </g>
                    </g>
                    <g> </g>
                    <g> </g>
                    <g> </g>
                    <g> </g>
                    <g> </g>
                    <g> </g>
                    <g> </g>
                    <g> </g>
                    <g> </g>
                    <g> </g>
                    <g> </g>
                    <g> </g>
                    <g> </g>
                    <g> </g>
                    <g> </g>
                  </svg> {{language.YOUR_ORDER}}
                </h4>
                <button class="sbm-btn cmn-button" style=" width: 100%;" *ngIf="businessDetails.laundrystatus == 0"
                  (click)="goToPreorder()">{{language.PREORDER}}</button>
                <mat-chip-list class="preorderText" #chipList *ngIf="preorderDetails.preorder == true">
                  <mat-chip [selectable]="selectable" [removable]="removable">
                    {{preorderDetails.preorderDateString}} -
                    {{preorderDetails.preorderTime}}
                    <i class="fa fa-times" aria-hidden="true" (click)="removePreorder()"></i>

                  </mat-chip>
                </mat-chip-list>

                <div class="pk-dl" *ngIf="businessDetails.is_delivery == '1' && businessDetails.is_pickup == '1'">
                  <mat-radio-group [(ngModel)]="orderType">
                    <ul>
                      <li [ngClass]="{'active': orderType == '2' }">
                        <mat-radio-button (click)="prePickupSearchHtml()" value="2">{{language.PICKUP}}
                        </mat-radio-button>
                      </li>
                      <li [ngClass]="{'active': orderType == '1' }">
                        <mat-radio-button (click)="deliverySearch()" value="1">{{language.DELIVERY}}
                        </mat-radio-button>
                      </li>
                    </ul>
                  </mat-radio-group>
                </div>
                <div class="pk-dl" *ngIf="businessDetails.is_delivery == '1' && businessDetails.is_pickup != '1'">
                  <mat-radio-group [(ngModel)]="orderType">
                    <ul>
                      <li class="w-100" [ngClass]="{'active': orderType == '1' }">
                        <mat-radio-button (click)="deliverySearch()" value="1">{{language.DELIVERY_ONLY}}
                        </mat-radio-button>
                      </li>
                    </ul>
                  </mat-radio-group>
                </div>
                <div class="pk-dl" *ngIf="businessDetails.is_delivery != '1' && businessDetails.is_pickup == '1'">
                  <mat-radio-group [(ngModel)]="orderType">
                    <ul>
                      <li class="w-100" [ngClass]="{'active': orderType == '2' }">
                        <mat-radio-button (click)="prePickupSearchHtml()" value="2">{{language.PICKUP_ONLY}}
                        </mat-radio-button>
                      </li>
                    </ul>
                  </mat-radio-group>
                </div>

                <div class="cart-item-grp">
                  <ngx-simplebar [options]="options">
                    <div *ngFor="let cartdish of CartDish;let cartindex = index">
                      <div *ngFor="let cdish of cartdish['dish'];let dishindex = index">
                        <div class="cart-item" *ngFor="let dish of cdish['data'];let dataindex = index">
                          <div class="cart-top">
                            <div class="crt-nm-dtls">
                              <h5>{{dish.name}}</h5>
                            </div>
                            <div class="crt-edt">
                              <a href="javascript:void(0);" (click)="editProduct(cartindex,dishindex, dataindex)">
                                <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                                  xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                  viewBox="0 0 469.336 469.336" style="enable-background:new 0 0 469.336 469.336;"
                                  xml:space="preserve">
                                  <g>
                                    <g>
                                      <path
                                        d="M456.836,76.168l-64-64.054c-16.125-16.139-44.177-16.17-60.365,0.031L45.763,301.682
                         c-1.271,1.282-2.188,2.857-2.688,4.587L0.409,455.73c-1.063,3.722-0.021,7.736,2.719,10.478c2.031,2.033,4.75,3.128,7.542,3.128
                         c0.979,0,1.969-0.136,2.927-0.407l149.333-42.703c1.729-0.5,3.302-1.418,4.583-2.69l289.323-286.983
                         c8.063-8.069,12.5-18.787,12.5-30.192S464.899,84.237,456.836,76.168z M285.989,89.737l39.264,39.264L120.257,333.998
                         l-14.712-29.434c-1.813-3.615-5.5-5.896-9.542-5.896H78.921L285.989,89.737z M26.201,443.137L40.095,394.5l34.742,34.742
                         L26.201,443.137z M149.336,407.96l-51.035,14.579l-51.503-51.503l14.579-51.035h28.031l18.385,36.771
                         c1.031,2.063,2.708,3.74,4.771,4.771l36.771,18.385V407.96z M170.67,390.417v-17.082c0-4.042-2.281-7.729-5.896-9.542
                         l-29.434-14.712l204.996-204.996l39.264,39.264L170.67,390.417z M441.784,121.72l-47.033,46.613l-93.747-93.747l46.582-47.001
                         c8.063-8.063,22.104-8.063,30.167,0l64,64c4.031,4.031,6.25,9.385,6.25,15.083S445.784,117.72,441.784,121.72z" />
                                    </g>
                                  </g>
                                  <g>
                                  </g>
                                  <g>
                                  </g>
                                  <g>
                                  </g>
                                  <g>
                                  </g>
                                  <g>
                                  </g>
                                  <g>
                                  </g>
                                  <g>
                                  </g>
                                  <g>
                                  </g>
                                  <g>
                                  </g>
                                  <g>
                                  </g>
                                  <g>
                                  </g>
                                  <g>
                                  </g>
                                  <g>
                                  </g>
                                  <g>
                                  </g>
                                  <g>
                                  </g>
                                </svg>
                              </a>
                              <div class="edt-btns">
                                <button type="button" (click)="addTocartDecrement(cartindex,dishindex, dataindex)">
                                  <svg width="15px" height="15px" viewBox="0 0 512 512" version="1.1" id="Capa_1"
                                    xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                    x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;"
                                    xml:space="preserve">
                                    <g>
                                      <g>
                                        <rect y="236" width="512" height="40" />
                                      </g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                  </svg>
                                </button>
                                <span>{{dish.quantity}}</span>
                                <button type="button" (click)="addTocartIncrement(cartindex,dishindex, dataindex)">
                                  <svg width="15px" height="15px" viewBox="0 0 512 512" version="1.1" id="Capa_1"
                                    xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                    x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;"
                                    xml:space="preserve">
                                    <g>
                                      <g>
                                        <polygon
                                          points="276,236 276,0 236,0 236,236 0,236 0,276 236,276 236,512 276,512 276,276 512,276 512,236 		" />
                                      </g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                  </svg>
                                </button>
                              </div>
                            </div>
                            <div class="crt-prc">
                              <span>{{businessDetails.currency_symbol}}{{dish.total}}</span>
                            </div>
                          </div>
                          <div class="crt-optn">
                            <p *ngIf="dish.activeIngredients.length > 0" class="optn-lft">
                              <span>
                                <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                                  xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512"
                                  style="enable-background:new 0 0 512 512;" xml:space="preserve">
                                  <g>
                                    <g>
                                      <polygon
                                        points="276,236 276,0 236,0 236,236 0,236 0,276 236,276 236,512 276,512 276,276 512,276 512,236 		" />
                                    </g>
                                  </g>
                                  <g>
                                  </g>
                                  <g>
                                  </g>
                                  <g>
                                  </g>
                                  <g>
                                  </g>
                                  <g>
                                  </g>
                                  <g>
                                  </g>
                                  <g>
                                  </g>
                                  <g>
                                  </g>
                                  <g>
                                  </g>
                                  <g>
                                  </g>
                                  <g>
                                  </g>
                                  <g>
                                  </g>
                                  <g>
                                  </g>
                                  <g>
                                  </g>
                                  <g>
                                  </g>
                                </svg>
                              </span> {{language.INGREDIENTS}} - {{dish.activeIngredientsText}}
                            </p>
                            <p *ngFor="let set of dish.sets" class="optn-lft">
                              <span>
                                <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                                  xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512"
                                  style="enable-background:new 0 0 512 512;" xml:space="preserve">
                                  <g>
                                    <g>
                                      <polygon
                                        points="276,236 276,0 236,0 236,236 0,236 0,276 236,276 236,512 276,512 276,276 512,276 512,236 		" />
                                    </g>
                                  </g>
                                  <g>
                                  </g>
                                  <g>
                                  </g>
                                  <g>
                                  </g>
                                  <g>
                                  </g>
                                  <g>
                                  </g>
                                  <g>
                                  </g>
                                  <g>
                                  </g>
                                  <g>
                                  </g>
                                  <g>
                                  </g>
                                  <g>
                                  </g>
                                  <g>
                                  </g>
                                  <g>
                                  </g>
                                  <g>
                                  </g>
                                  <g>
                                  </g>
                                  <g>
                                  </g>
                                </svg>
                              </span> {{set.name}} - {{set.choiceText}}
                            </p>
                          </div>
                          <div class="crt-nots" *ngIf="dish.notes != ''">
                            <p>{{dish.notes}}</p>
                          </div>


                          <div *ngIf="businessDetails.buyone_getone_status">
                            <div *ngFor="let fdish of dish.free.data">
                              <div class="cart-top">
                                <div class="crt-nm-dtls">
                                  <h5>{{fdish.name}} <small style="color: red;">(Free)</small></h5>
                                </div>
                              </div>
                              <div class="crt-optn">
                                <p *ngIf="fdish.activeIngredients.length > 0" class="optn-lft">
                                  <span>
                                    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512"
                                      style="enable-background:new 0 0 512 512;" xml:space="preserve">
                                      <g>
                                        <g>
                                          <polygon
                                            points="276,236 276,0 236,0 236,236 0,236 0,276 236,276 236,512 276,512 276,276 512,276 512,236 		" />
                                        </g>
                                      </g>
                                      <g>
                                      </g>
                                      <g>
                                      </g>
                                      <g>
                                      </g>
                                      <g>
                                      </g>
                                      <g>
                                      </g>
                                      <g>
                                      </g>
                                      <g>
                                      </g>
                                      <g>
                                      </g>
                                      <g>
                                      </g>
                                      <g>
                                      </g>
                                      <g>
                                      </g>
                                      <g>
                                      </g>
                                      <g>
                                      </g>
                                      <g>
                                      </g>
                                      <g>
                                      </g>
                                    </svg>
                                  </span> {{language.INGREDIENTS}} - {{fdish.activeIngredientsText}}
                                </p>
                                <p *ngFor="let freeset of fdish.sets" class="optn-lft">
                                  <span>
                                    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512"
                                      style="enable-background:new 0 0 512 512;" xml:space="preserve">
                                      <g>
                                        <g>
                                          <polygon
                                            points="276,236 276,0 236,0 236,236 0,236 0,276 236,276 236,512 276,512 276,276 512,276 512,236 		" />
                                        </g>
                                      </g>
                                      <g>
                                      </g>
                                      <g>
                                      </g>
                                      <g>
                                      </g>
                                      <g>
                                      </g>
                                      <g>
                                      </g>
                                      <g>
                                      </g>
                                      <g>
                                      </g>
                                      <g>
                                      </g>
                                      <g>
                                      </g>
                                      <g>
                                      </g>
                                      <g>
                                      </g>
                                      <g>
                                      </g>
                                      <g>
                                      </g>
                                      <g>
                                      </g>
                                      <g>
                                      </g>
                                    </svg>
                                  </span> {{freeset.name}} - {{freeset.choiceText}}
                                </p>
                              </div>
                              <div class="crt-nots" *ngIf="fdish.notes != ''">
                                <p>{{fdish.notes}}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="note" *ngIf="CartDish.length == 0">
                      <p>{{language.NO_ITEM_IN_BASKET}}</p>
                    </div>
                  </ngx-simplebar>
                </div>
                <div *ngIf="CartDish.length > 0">
                  <div class="sub-ttl">
                    <h5>{{language.ORDER_TEMPLATE_SUB_TOTAL}}
                      <span>{{businessDetails.currency_symbol}}{{CartSubTotal}}</span></h5>
                  </div>
                  <div
                    *ngIf="(businessDetails.open == true || preorderDetails.preorder == true) && businessDetails.bclosed == false">
                    <div class="nots" [ngClass]="{'wrng': !PendingFreeDelivery, 'scs': PendingFreeDelivery}"
                      *ngIf="orderType == '1' && businessDetails.freedeliverystatus == '1'">
                      <p *ngIf="!PendingFreeDelivery">
                        {{language.MINIMUM_FREE_COND_1}}{{businessDetails.currency_symbol}}{{PendingFreeDeliveryValue}}
                        {{language.MINIMUM_FREE_COND_2}}</p>
                      <p *ngIf="PendingFreeDelivery">{{language.MINIMUM_FREE_DELIVERY_MSG}}</p>
                    </div>


                    <div *ngIf="businessDetails.requiredminimumstatus != '1'">
                      <button class="sbm-btn cmn-button" style=" width: 100%;" *ngIf="PendingMinimumFee <= 0.00"
                        (click)="pregoToCheckout('1')">{{language.CONFIRM_ORDER}}</button>
                      <div class="nots wrng" *ngIf="PendingMinimumFee > 0.00">
                        <p>{{language.MINIMU_PRICE_NEED_TO_ADD}}
                          {{businessDetails.currency_symbol}}{{PendingMinimumFee}}</p>
                      </div>

                      <button class="sbm-btn cmn-button" style=" width: 100%;"
                        *ngIf="PendingMinimumFee > 0.00">{{language.MINIMUM_ORDER}}:
                        {{businessDetails.currency_symbol}}{{businessDetails.minimumfee}}</button>
                    </div>

                    <div *ngIf="businessDetails.requiredminimumstatus == '1'">
                      <button class="sbm-btn cmn-button" style=" width: 100%;"
                        (click)="pregoToCheckout('2')">{{language.CONFIRM_ORDER}}</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="tab-pane" id="business">
        <ng-template #businessSubContainer1></ng-template>
      </div>
      <div class="tab-pane" id="photos">
        <ng-template #businessSubContainer2></ng-template>
      </div>
      <div class="tab-pane" id="reviews">
        <ng-template #businessSubContainer3></ng-template>
      </div>
      <div class="tab-pane" id="offers">
        <ng-template #businessSubContainer4></ng-template>
      </div>
      <div class="tab-pane" id="booking">
        <ng-template #businessSubContainer5></ng-template>
      </div>
    </div>
  </div>
</div>
